import React from 'react';
import { Box, Typography } from '@mui/material';
import ColorPalette from '../../../../colorpalette/ColorPalette';

/**
 * Passo a passo escrito da lição, em lista numerada.
 * @param {Object} lesson - { id, steps: [String] }
 */
const LessonSteps = ({ lesson }) => {
  const steps = Array.isArray(lesson.steps) ? lesson.steps : [];
  if (steps.length === 0) return null;

  return (
    <Box>
      <Typography sx={{ fontWeight: 700, color: '#1A1A2E', fontSize: '0.9rem', mb: 1.25 }}>
        Passo a passo
      </Typography>
      <Box component="ol" sx={{ listStyle: 'none', m: 0, p: 0, display: 'flex', flexDirection: 'column', gap: 1 }}>
        {steps.map((step, stepIndex) => (
          <Box component="li" key={`${lesson.id}-${stepIndex}`} sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
            <Box
              sx={{
                width: 22,
                height: 22,
                flexShrink: 0,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '0.7rem',
                fontWeight: 700,
                backgroundColor: ColorPalette.blueAlpha,
                color: ColorPalette.blueMain,
                mt: '1px'
              }}
            >
              {stepIndex + 1}
            </Box>
            <Typography sx={{ color: ColorPalette.textMedium, fontSize: '0.875rem', lineHeight: 1.55 }}>
              {step}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default LessonSteps;
